import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from './Card';
import { Tool } from '../types';

interface ToolCardProps {
  tool: Tool;
}

const ToolCard: React.FC<ToolCardProps> = ({ tool }) => {
  const navigate = useNavigate();

  return (
    <Card
      hoverable
      onClick={() => navigate(tool.path)}
      className="border border-border"
    >
      <div className="text-5xl mb-16">{tool.icon}</div>
      <h3 className="text-xl font-bold text-textPrimary mb-8">{tool.name}</h3>
      <p className="text-sm text-textSecondary">{tool.description}</p>
    </Card>
  );
};

export default ToolCard;
